import { AbstractControl } from '@angular/forms';

export function GreaterThanZeroValidator(control: AbstractControl) {
  const value = control.value;
  if (value < 0) {
    return { validNumber: true };
  }
  return null;
}
